import actionTypes from '../actionTypes';
import { STANDARDVIEW } from '../../constants/constant';

const initialState = {
	isFirstTimeUser: false,
	dsADAlertDisabled: true,
	dsADAlertDisabledError: false,
	firstTimeUserError: null,
	isCatman: false,
	selectedView: STANDARDVIEW,
	isUPC: true,
};

const appGuideReducer = (state = initialState, action = {}) => {
	switch (action?.type) {
		case actionTypes.SET_FIRST_TIME_USER:
			return {
				...state,
				isFirstTimeUser: action.payload?.firstTimeUser,
				dsADAlertDisabled: action.payload?.dsADAlertDisabled,
			};
		case actionTypes.SAVE_FIRST_TIME_USER_STATUS_SUCCESS:
			return {
				...state,
				isFirstTimeUser: false,
			};
		case actionTypes.SAVE_FIRST_TIME_USER_STATUS_FAILURE:
			return {
				...state,
				isFirstTimeUser: true,
				firstTimeUserError: action.payload,
			};

		case actionTypes.SET_PERSONA:
			return {
				...state,
				isCatman: action.payload,
			};

		case actionTypes.CHANGE_PERSONA:
			return {
				...state,
				selectedView: action.payload,
			};

		case actionTypes.SELECTED_UPC:
			return {
				...state,
				isUPC: action.payload,
			};

		case actionTypes.DISABLE_DSADALERT:
			return {
				...state,
				dsADAlertDisabled: action.payload?.dsADAlertDisabled,
			};

		case actionTypes.DISABLE_DSADALERT_SUCCESS:
			return {
				...state,
				dsADAlertDisabled: action.payload?.dsADAlertDisabled,
			};
		case actionTypes.DISABLE_DSADALERT_FAILURE:
			return {
				...state,
				isFirstTimeUser: true,
				dsADAlertDisabledError: action.payload,
				dsADAlertDisabled: action.payload?.dsADAlertDisabled,
			};
		default:
			return state;
	}
};

export default appGuideReducer;
